import React from 'react';
import { useSelector } from 'react-redux';
import { InstoreCategoryCard } from 'common/components';
import { getInstoreCategoryData } from 'utils';
import { selectCategories } from '../../../selectors';
import { allServicesCardStyles, StyledDiv } from './styles';
import { selectPageModelStoreName } from 'store/pageModel';

export const CardsContainer = () => {
	const categories = useSelector(selectCategories);

	const storeName = useSelector(selectPageModelStoreName);

	return (
		<StyledDiv>
			{categories.map(category => {
				const cardData = getInstoreCategoryData(category, storeName);
				return (
					<InstoreCategoryCard
						key={`card-${category.name}`}
						{...cardData}
						className={allServicesCardStyles}
					/>
				);
			})}
		</StyledDiv>
	);
};
